import { useContext, useEffect, useMemo, useState } from 'react'
import { enqueueSnackbar } from 'notistack'

import { AppContext } from '/providers/app-context'
import { getClientStatistics } from '/providers/clients-api'

export const periodOptions = [
  { label: '1 day', value: 1 },
  { label: '1 week', value: 7 },
  { label: '1 month', value: 31 },
  { label: '3 months', value: 92 },
  { label: '6 months', value: 183 },
  { label: '12 months', value: 365 }
]

const emptyTotals = { issued: 0, updated: 0, notified: 0 }
const emptyExtraTotals = { templatesCreated: 0, templateUpdates: 0, appleInstalls: 0, googleInstalls: 0, scans: 0, activePasses: 0, expiredPasses: 0 }

export const defaultStatistics = {
  trend: [],
  adoption: [],
  templateLifecycle: [],
  installTrend: [],
  scanTrend: [],
  passTypeMix: [],
  totals: emptyTotals,
  extraTotals: emptyExtraTotals
}

const useClientStatistics = () => {
  const { user, apiSource, apiKey, templates, loadingTemplates, selectedClientId } = useContext(AppContext)
  const [periodDays, setPeriodDays] = useState(31)
  const [templateId, setTemplateId] = useState('')
  const [statistics, setStatistics] = useState(defaultStatistics)
  const [loading, setLoading] = useState(false)

  const selectableTemplates = useMemo(
    () => (templates || []).filter(template => !template.archived).sort((a, b) => (a.name || '').localeCompare(b.name || '')),
    [templates]
  )

  useEffect(() => {
    const loadStatistics = async () => {
      setLoading(true)
      const result = await getClientStatistics({
        apiSource,
        apiKey,
        period_days: periodDays,
        template_id: templateId || undefined
      })
      setLoading(false)

      if (result.ok) {
        setStatistics({
          trend: result.trend || [],
          adoption: result.adoption || [],
          templateLifecycle: result.templateLifecycle || [],
          installTrend: result.installTrend || [],
          scanTrend: result.scanTrend || [],
          passTypeMix: result.passTypeMix || [],
          totals: result.totals || emptyTotals,
          extraTotals: result.extraTotals || emptyExtraTotals
        })
      }
      else {
        enqueueSnackbar({ message: result.error, variant: 'error' })
      }
    }

    if (user?.permissions.client_admin && !loadingTemplates) {
      loadStatistics()
    }
  }, [user, apiSource, apiKey, periodDays, templateId, loadingTemplates, selectedClientId])

  return {
    loading,
    periodDays,
    setPeriodDays,
    selectableTemplates,
    statistics,
    templateId,
    setTemplateId
  }
}

export default useClientStatistics
